<template>
  <div id="main-gear-wrap">
    <span class="coin">
      <p>Coin:</p>
      <input type="number" min="0" :value="coin" @input="changeCoin" />
    </span>
    <span class="weight">
      <p>Weight: {{ weight }}</p>
      <p class="subnote">Max Load ({{ maxWeight }}+STR)</p>
    </span>
  </div>
</template>
<script>
export default {
  name: "CharacterMainGear",
  props: ["coin", "weight", "maxWeight"],
  methods: {
    changeCoin: function(e) {
      this.$emit("changeCoin", e.target.value);
    }
  }
};
</script>
<style lang="css">
#main-gear-wrap {
  width: 90%;
  margin: 0.5em 0;
  display: flex;
  justify-content: space-evenly;
  align-items: baseline;
}

#main-gear-wrap p {
  margin-bottom: 0;
}

#main-gear-wrap .coin {
  display: flex;
  align-items: baseline;
}

#main-gear-wrap .coin input {
  width: 1.8em;
  height: 1.8em;
  margin-left: 0.5em;
  text-align: center;
  border-radius: 100%;
}
</style>